import { API_ENDPOINTS } from "@/api/services/leaveManagement/apiEndpoints";
import { baseApi } from "@/utils/baseApi";


export const leaveTypeCategoryApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchLeaveTypeCategory: builder.query({
            query: (name) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.FETCH_LEAVE_TYPE_CATEGORY,
                method: "GET",
            }),

            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [{ type: "LeaveTypeCategory", id: "LIST" }]
                    : [{ type: "LeaveTypeCategory", id: "LIST" }],
        }),

         fetchLeaveTypeName: builder.query({
            query: (name) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.FETCH_LEAVE_TYPE_NAME,
                method: "GET",
            }),

        }),

        postLeaveCategory: builder.mutation({
            query: ({ org, formData }) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.ADD_LEAVE_TYPE_CATEGORY(org),
                method: "POST",
                body: formData,
            }),

            invalidatesTags: [{ type: "LeaveTypeCategory", id: "LIST" }],
        }),
        fetchLeaveScheme: builder.query({
            query: () => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.FETCH_LEAVE_SCHEME,
                method: "GET",
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [{ type: "LeaveScheme", id: "LIST" }]
                    : [{ type: "LeaveScheme", id: "LIST" }],
        }),

        postLeaveScheme: builder.mutation({
            query: ({ org, formData }) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.ADD_LEAVE_SCHEME(org),
                method: "POST",
                body: formData,
            }),
            invalidatesTags: [{ type: "LeaveScheme", id: "LIST" }],
        }),

        deleteLeaveCategory: builder.mutation({

            query: (id) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.DELETE_LEAVE_TYPE_CATEGORY(id),
                method: "DELETE",
            }),
            invalidatesTags: [{ type: "LeaveTypeCategory", id: "LIST" }],
        }),

        deleteLeaveScheme: builder.mutation({
            query: (id) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.DELETE_LEAVE_SCHEME(id),
                method: "DELETE",
            }),
            invalidatesTags: [{ type: "LeaveScheme", id: "LIST" }],
        }),

        updateLeaveCategoty: builder.mutation({
            query: ({ formData, id }) => ({
                url: API_ENDPOINTS.LEAVE_TYPE_CATEGORY.UPDATE_LEAVE_TYPE_CATEGORY(id),
                method: "PUT",
                body: formData,
            }),
            invalidatesTags: [{ type: "LeaveTypeCategory", id: "LIST" }],


        }),

    }),

});

export const { useFetchLeaveTypeCategoryQuery, usePostLeaveCategoryMutation, useFetchLeaveSchemeQuery, usePostLeaveSchemeMutation, useDeleteLeaveCategoryMutation, useUpdateLeaveCategotyMutation, useDeleteLeaveSchemeMutation,useFetchLeaveTypeNameQuery } = leaveTypeCategoryApi;
